import { ApplicationTypeEnum } from '../../../legacy/shared-types';

export const introductionQuestions: Record<string, any> = {
  purchaseType: {
    id: 'purchaseOptions',
    labelKey: 'introduction.buyOrRefinance',
    options: [
      {
        labelKey: 'common.term.purchase',
        value: ApplicationTypeEnum.PURCHASE,
      },
      {
        labelKey: 'common.term.refinance',
        value: ApplicationTypeEnum.REFINANCE,
      },
    ],
  },
};
